<script lang="ts" setup>
  import '@tato30/vue-pdf/style.css'

  import { onMounted, onUnmounted, ref } from 'vue'
  import type { VNodeRef } from 'vue'
  import { usePDF } from '@/store/pdfStore'
  import { VuePDF } from '@tato30/vue-pdf'
  import type { PDFDocumentLoadingTask } from 'pdfjs-dist/legacy/build/pdf'

  defineProps({
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  })
  // @ts-ignore
  const pdf = usePDF()
  const vuePDFRef = ref<VNodeRef | undefined>(undefined)

  function handleWindowSizeChange() {
    // handling resize on Android devices is not working properly
    // so we only reload the pdf on resizes on other devices
    const isAndroid = /Android/i.test(navigator.userAgent)

    if (!isAndroid) {
      if (vuePDFRef.value) {
        vuePDFRef.value.reload()
      }
    }
  }

  onMounted(() => {
    window.addEventListener('resize', handleWindowSizeChange)
  })

  onUnmounted(async () => {
    window.removeEventListener('resize', handleWindowSizeChange)
  })
</script>

<template>
  <div class="pdf-display-wrapper">
    <VuePDF
      v-if="pdf.loadingTask"
      ref="vuePDFRef"
      class="pdf"
      data-cy="pdfDisplayDiv"
      annotation-layer
      fit-parent
      on-layer
      text-layer
      :annotations-map="pdf.annotationStorage"
      :hide-forms="!pdf.editable || !editable"
      :page="pdf.page"
      :pdf="pdf.loadingTask as PDFDocumentLoadingTask"
      @annotation="pdf.onAnnotation"
      @loaded="pdf.onLoaded"
    ></VuePDF>
    <div
      v-else
      class="spinner-border"
      role="status"
    ></div>
    <!-- <div
    class="debug-warning"
    v-else>
    Not rendering VuePDF container because
    <span class="debug-highlight">form.pdf</span> is {{ typeof form.pdf }}.
</div> -->
  </div>
</template>

<style scoped>
  .pdf-display-wrapper {
    width: 100%;
    overflow: hidden;
  }

  .pdf :deep(.linkAnnotation) {
    cursor: pointer;
  }

  /* Ensure PDF fits container on mobile */
  @media (max-width: 767px) {
    .pdf-display-wrapper {
      max-width: 100%;
      overflow-x: hidden;
    }

    .pdf :deep(canvas) {
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
    }

    .pdf :deep(.textLayer),
    .pdf :deep(.annotationLayer) {
      max-width: 100% !important;
    }
  }
</style>
